import {IProfile} from '../pages/Profile/types';
import {hasActiveTariff} from './tariffFormat';

/** Free — состояние текущей компании до первой покупки, включая нулевой остаток. */
export const isFreeCompany = (profile?: IProfile): boolean => Boolean(
    profile?.sys_company_id && profile.free_access && !profile.free_access.has_ever_paid && !hasActiveTariff(profile.tariff),
);

export const canUseFreeViews = (profile?: IProfile): boolean => Boolean(
    profile?.email_verified_at && isFreeCompany(profile) && profile.free_access?.eligible,
);
